<acs-modal 
  [isOpen]="showModal" 
  [title]="'Session Expiring'"
  [showCloseButton]="false"
  [size]="'medium'"
  [closeOnBackdropClick]="false"
  (closed)="onDismiss()">
  
  <div class="session-warning-content">
    <!-- Warning Icon -->
    <div class="text-center mb-3">
      <i class="fas fa-clock fa-3x text-warning" *ngIf="sessionWarning.timeRemaining !== 'expired'"></i>
      <i class="fas fa-exclamation-triangle fa-3x text-danger" *ngIf="sessionWarning.timeRemaining === 'expired'"></i>
    </div>

    <!-- Warning Message -->
    <div class="text-center mb-4">
      <h5 class="mb-2" *ngIf="sessionWarning.timeRemaining !== 'expired'">Your session is about to expire</h5>
      <h5 class="mb-2 text-danger" *ngIf="sessionWarning.timeRemaining === 'expired'">Session Authentication Required</h5>
      
      <p class="mb-1" *ngIf="sessionWarning.timeRemaining !== 'expired'">
        Your session will expire in 
        <strong [class]="timeRemainingClass">{{ sessionWarning.timeRemaining }}</strong>
      </p>
      
      <p class="mb-1 text-warning" *ngIf="sessionWarning.timeRemaining === 'expired'">
        Your authentication session has expired and cannot be renewed automatically.
      </p>
      
      <small class="text-muted" *ngIf="sessionWarning.canRefresh">
        Would you like to extend your session?
      </small>
      
      <small class="text-muted" *ngIf="!sessionWarning.canRefresh">
        Please log in again to continue.
      </small>
    </div>

    <!-- Session Info -->
    <div class="session-info mb-4 p-3 bg-light rounded">
      <div class="row">
        <div class="col-6">
          <small class="text-muted">Current Time:</small>
          <div class="fw-semibold">{{ currentTime | date:'short' }}</div>
        </div>
        <div class="col-6">
          <small class="text-muted">Expires At:</small>
          <div class="fw-semibold">{{ sessionWarning.expiresAt | date:'short' }}</div>
        </div>
      </div>
    </div>

    <!-- Action Buttons -->
    <div class="d-flex justify-content-center gap-3">
      <!-- Extend Session Button -->
      <acs-button
        *ngIf="sessionWarning.canRefresh"
        [variant]="'primary'"
        [size]="'medium'"
        [disabled]="isExtending"
        [loading]="isExtending"
        (clicked)="onExtendSession()">
        {{ isExtending ? 'Extending...' : 'Extend Session' }}
      </acs-button>

      <!-- Cannot Extend Message -->
      <div *ngIf="!sessionWarning.canRefresh" class="alert alert-warning w-100 text-center mb-3">
        <i class="fas fa-exclamation-triangle"></i>
        Session cannot be extended. Please log in again.
      </div>

      <!-- Logout Button -->
      <acs-button
        [variant]="'secondary'"
        [size]="'medium'"
        [disabled]="isExtending"
        (clicked)="onLogout()">
        Logout
      </acs-button>

      <!-- Dismiss Button (only if can refresh) -->
      <acs-button
        *ngIf="sessionWarning.canRefresh"
        [variant]="'text'"
        [size]="'small'"
        [disabled]="isExtending"
        (clicked)="onDismiss()">
        Continue Working
      </acs-button>
    </div>

    <!-- Warning Footer -->
    <div class="mt-4 text-center">
      <small class="text-muted">
        <i class="fas fa-info-circle"></i>
        If no action is taken, you will be automatically logged out when the session expires.
      </small>
    </div>
  </div>
</acs-modal>